import { useSearchParams } from 'react-router-dom';
import useRecaptcha from 'hooks/useRecaptcha';
import { Hotel } from 'ts/hotel/interfaces/HotelResponse';
import { searchSerpHotels } from 'services/hotel';
import { parseRoomsOccupancy } from 'utils/hotel';

export const useLoadGoogle = () => {
  const [urlParams] = useSearchParams();
  const { handleRecapcha } = useRecaptcha();

  const loadGoogle = async (lang: string, hotel: Hotel, searchToken: string) => {
    const token = await handleRecapcha();
    if (!token) {
      return undefined;
    }
    const occupancy = parseRoomsOccupancy(urlParams.get('roomsString') || '');
    const hotelRoom = hotel.roomClasses?.[0]?.hotelRooms?.[0];
    const childrenAgesFromPax = Array.isArray(hotelRoom?.pax?.childrenAges)
      ? hotelRoom.pax.childrenAges
          .map((age: unknown) => Number(age))
          .filter((age: number) => Number.isFinite(age) && age >= 0)
      : [];
    const childrenAges =
      occupancy.childrenAges.length > 0 ? occupancy.childrenAges : childrenAgesFromPax;
    const child = childrenAges.length || hotelRoom?.numCnn || 0;

    const countryCode = urlParams.get('id') || '';
    const hasNumbers = /\d/.test(countryCode);
    const newRes = await searchSerpHotels({
      searchToken,
      countryCode: hasNumbers ? '' : countryCode,
      recaptchaToken: token,
      cleanHotelName: hotel.item.name,
      bpid: hotel.item.bpid,
      lat: hotel.position.latitude,
      lon: hotel.position.longitude,
      cleanAddress: hotel.addressInfo.address,
      query: {
        q: `Hotel: ${hotel.item.name}. Address: ${hotel.addressInfo.address} ${hotel.addressInfo.city} ${hotel.addressInfo.country}`,
        gL: 'il',
        hl: lang,
        checkIn: urlParams.get('checkIn') || '',
        checkOut: urlParams.get('checkOut') || '',
        adults: occupancy.adults || hotelRoom?.numAdt || 2,
        children: child,
        ...(child > 0 ? { childrenAges } : {}),
        currency: sessionStorage.getItem('displayCurrencyHotels')?.toUpperCase() || 'USD',
      },
    });

    return newRes;
  };

  return {
    loadGoogle,
  };
};
